import { combineReducers } from 'redux'
import { feedbackReducer } from '../../../legacy/utils/reducers'
import { settingsReducer, statusReducer } from '../../../legacy/utils/slices'
import {
  doDownload,
  downloadAction,
  printAction,
  uploadAction,
} from '../../../utils/actions'
import { formatInputJobList, getJobModel } from '../common/calculationUtils'
import { appConfig } from '../common/constants'
import {
  crackInjectionCalculationUpload,
  dowelingCalculationUpload,
} from './calculationAction'
import { calculationReducer } from './calculationReducer'
import { staticDataReducer } from './staticDataReducer'

const defaultReducer = (state = [], action) => {
  switch (action.type) {
    default:
      return state
  }
}

const appReducer = combineReducers({
  staticData: staticDataReducer,
  calculation: calculationReducer,
  settings: settingsReducer,
  status: statusReducer,
  feedback: feedbackReducer,
  calculationDoweling: defaultReducer,
  calculationCI: defaultReducer,
})

const getDefaultStatus = (list) => {
  const count = list && list.length > 0 ? list.length - 1 : null
  return {
    updatedCounter: -1,
    isLoading: false,
    isError: false,
    updateJobIndex: count,
  }
}

const reCalculate = (input, staticData) => {
  const { subApp } = input
  let myOutput = {}
  let myStatus = getDefaultStatus(input.jobList)
  let response = {}

  if (subApp === '0') {
    // for each job's userInput, recalculate
    const outputJobs = input.jobList.map((item, index) => {
      if (input.jobList.length === index + 1) {
        item.userInputs.validation = input.validation
      }
      response = dowelingCalculationUpload(item.userInputs, staticData)
      let oneJob = {}
      if (response.results) {
        // successful
        const modelObj = getJobModel(response.results)
        oneJob = Object.assign({}, { jobName: item.jobName }, modelObj, {
          userInputs: item.userInputs,
        })
      } else {
        oneJob = Object.assign({}, { jobName: item.jobName }, { userInputs: item.userInputs })
      }
      return oneJob
    })
    delete input.jobList
    if (response.results) {
      myOutput = Object.assign({}, { results: response.results }, { jobs: outputJobs })
    } else {
      myOutput = Object.assign({}, { results: [] }, { jobs: outputJobs })
      myStatus = Object.assign({}, myStatus, response)
    }

    return { output: myOutput, status: myStatus }
  } else {
    const response = crackInjectionCalculationUpload(input, staticData)
    if (response.msgLevel) {
      myStatus = Object.assign({}, myStatus, response)
      myOutput = {
        injectionResinResults: [],
        pasteOverEpoxyResults: [],
        pumpingPortsResults: [],
        injectionFittingsResults: [],
      }
    } else {
      myOutput = Object.assign({}, response)
    }
    return { output: myOutput, status: myStatus }
  }
}

export const rootReducer = (state, action) => {

  if (action.type === uploadAction.type) {
    const { source, sourceDomain } = state.calculation.input
    const { input } = action.payload.calculation
    const { output, status } = reCalculate(input, state.staticData)

    if (state.calculation.input.subApp === '0') {
      state.calculationDoweling = Object.assign({}, state.calculation)
    } else {
      state.calculationCI = Object.assign({}, state.calculation)
    }

    state.calculation = action.payload.calculation
    state.calculation.input = Object.assign({}, state.calculation.input, {
      source: source,
      sourceDomain: sourceDomain,
    })
    state.calculation.output = Object.assign({}, output)
    state.calculation.status = Object.assign({}, status)


    return Object.assign({}, state)
  } else if (action.type === downloadAction.type) {
    let myInput = Object.assign({}, state.calculation.input)
    delete myInput.source
    delete myInput.sourceDomain

    if (state.calculation.input.subApp === '0') {
      const jobList = formatInputJobList(state.calculation.output.jobs)
      myInput.jobList = jobList
    }

    const downloadContent = {
      appCode: appConfig.appCode,
      appVersion: appConfig.appVersion,
      calculation: {
        input: myInput,
      },
    }
    doDownload(downloadContent, appConfig.downloadFileName)


    return Object.assign({}, state)
  } else if (action.type === printAction.type) {
    return Object.assign({}, state)
  } else if (action.type === 'USER_LOGGED_OUT') {
    state = undefined
  } else if (action.type === 'SWITCH_SUBAPP') {
    // store state first
    if (action.payload.subApp === '0') {
      // switch from CI to Doweling
      state.calculationCI = Object.assign({}, state.calculation)
    } else {
      // switch from Doweling to CI
      state.calculationDoweling = Object.assign({}, state.calculation)
    }
    // set the state
    if (action.payload.subApp === '1') {
      state.calculation.output = {}
      if (state.calculationCI && state.calculationCI.input) {
        // if CI already existed
        state.calculation = state.calculationCI
      } else {
        state.calculation.input = action.payload.initialState
      }
    } else {
      if (state.calculationDoweling && state.calculationDoweling.input) {
        // if Doweling already existed
        state.calculation = state.calculationDoweling
      } else {
        state.calculation.input = action.payload.initialState
      }
    }
    return Object.assign({}, state)
  }

  return appReducer(state, action)
}
